import { Box, useTheme } from "@mui/material";

const COLUMNS = [
  {
    label: "Now", opacity: 1,
    cards: [
      { accent: true },
      { bgAlpha: 0.09, borderAlpha: 0.10 },
      { bgAlpha: 0.07, borderAlpha: 0.08 },
      { bgAlpha: 0.05, borderAlpha: 0.06 },
    ],
  },
  {
    label: "Next", opacity: 0.82,
    cards: [
      { bgAlpha: 0.08, borderAlpha: 0.09 },
      { bgAlpha: 0.06, borderAlpha: 0.07 },
      { bgAlpha: 0.05, borderAlpha: 0.06 },
    ],
  },
  {
    label: "Later", opacity: 0.58,
    cards: [
      { bgAlpha: 0.06, borderAlpha: 0.07 },
      { bgAlpha: 0.045, borderAlpha: 0.055 },
    ],
  },
  {
    label: "Complete", opacity: 0.36,
    cards: [
      { bgAlpha: 0.05, borderAlpha: 0.06 },
    ],
  },
];

export default function HorizonField() {
  const theme = useTheme();
  const pv = theme.vars.palette.login; // only for template literals

  const styles = {
    root: {
      position: "absolute",
      top: 0,
      right: 0,
      width: "53%",
      height: "100%",
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      bgcolor: "login.columnGap",
      gap: "1px",
      WebkitMaskImage: "linear-gradient(90deg, transparent, #000 26%)",
      maskImage: "linear-gradient(90deg, transparent, #000 26%)",
    },
    column: {
      bgcolor: "login.background",
      padding: "56px 20px",
      display: "flex",
      flexDirection: "column",
      gap: "18px",
    },
    labelRow: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    dot: {
      width: 8,
      height: 8,
      borderRadius: "50%",
      flexShrink: 0,
    },
    label: {
      fontFamily: "'IBM Plex Mono', 'SF Mono', Consolas, monospace",
      fontSize: "11px",
      letterSpacing: "0.16em",
      textTransform: "uppercase",
    },
    card: {
      height: "44px",
      borderRadius: "9px",
    },
  };

  const getDotSx = (label) => ({
    ...styles.dot,
    bgcolor: label === "Now"   ? "login.accent"
           : label === "Next"  ? "login.nextDot"
           : label === "Later" ? "login.laterDot"
           : "login.completeDot",
    ...(label === "Now" && { boxShadow: `0 0 12px 2px ${pv.nowGlow}` }),
  });

  const getLabelSx = (label) => ({
    ...styles.label,
    color: label === "Now"  ? "login.nowLabel"
         : label === "Next" ? "login.nextLabel"
         : "login.laterLabel",
  });

  const getCardSx = (card) => ({
    ...styles.card,
    ...(card.accent
      ? {
          background: `linear-gradient(90deg, ${pv.nowCardAccent}, rgba(0,168,224,0.10))`,
          border: `1px solid ${pv.nowBorder}`,
        }
      : {
          background: `rgba(${pv.cardFgRgb}, ${card.bgAlpha})`,
          border: `1px solid rgba(${pv.cardFgRgb}, ${card.borderAlpha})`,
        }),
  });

  return (
    <Box sx={styles.root}>
      {COLUMNS.map((col) => (
        <Box key={col.label} style={{ opacity: col.opacity }} sx={styles.column}>
          <Box sx={styles.labelRow}>
            <Box sx={getDotSx(col.label)} />
            <Box component="span" sx={getLabelSx(col.label)}>
              {col.label}
            </Box>
          </Box>

          {col.cards.map((card, i) => (
            <Box key={i} sx={getCardSx(card)} />
          ))}
        </Box>
      ))}
    </Box>
  );
}
